import { useState } from "react";
import { Rating } from "react-simple-star-rating";
import { Col, Row } from "reactstrap";
import { RateNow } from "../../../../../Constants/Constants";
import { H6 } from "../../../../../AbstractElements";

export const ProductRating = () => {
  const [rating, setRating] = useState(3);
  const changeRating = (newRating: number) => {
    setRating(newRating);
  };
  return (
    <>
      <Row>
        <Col md="4">
          <H6 className="product-title mb-2">{RateNow}</H6>
        </Col>
        <Col md="8">
          <div className="d-flex">
            <div className="rating">
              <Rating onClick={changeRating} initialValue={rating} size={17} />
            </div>
            <span className="ms-2">(250 review)</span>
          </div>
        </Col>
      </Row>
      <hr />
    </>
  );
};
